import ImageSprite from "../../../assets/components/ImageSprite/ImageSprite";
import Table from "../../../assets/components/Table/Table";
import ArrowSprite from "../../../assets/components/Table/Img/arrow_sprite.svg";
import { ColumnDef } from "@tanstack/react-table";
import { FC } from "react";
import {
    ActivityRecord,
    ChangeType,
    FetchHistoryService,
    HistoryTable,
    renderSubComponentActivityRecordTable,
    TargetArea,
} from "../model";
import { getValueByKey } from "../helpers";
import HistorySubRow from "../HistorySubRow/HistorySubRow";
import moment from "moment";

const renderSubComponent: renderSubComponentActivityRecordTable = (props) => {
    return (
        <HistorySubRow
            activityRecord={{ ...props.row.original }}
            key={props.row.original.id}
        />
    );
};

interface Props {
    dataTable: FetchHistoryService["histories"];
}

const LicenseKeysTable: FC<Props> = ({ dataTable }) => {
    const columns: ColumnDef<ActivityRecord>[] = [
        {
            header: "Target Area",
            accessorFn: ({ targetArea }) =>
                getValueByKey(TargetArea, targetArea),
        },
        {
            header: "User Name",
            accessorFn: ({ userName }) => userName,
        },
        {
            header: "Action Date",
            accessorFn: ({ date }) => moment.unix(Number(date)).format("LLL"),
        },
        {
            header: "Action Type",
            accessorFn: ({ changeType }) =>
                getValueByKey(ChangeType, changeType),
        },

        {
            id: "expander",
            header: () => null,
            cell: ({ row }) => {
                const arrow = row.getIsExpanded() ? "arrowUp" : "arrowDown";
                return (
                    <button
                        className="edit_button"
                        {...{
                            onClick: () => row.getToggleExpandedHandler(),
                            style: { cursor: "pointer" },
                        }}
                    >
                        <ImageSprite iconSprite={`${ArrowSprite}#${arrow}`} />
                    </button>
                );
            },
        },
    ];

    return (
        <Table<HistoryTable>
            className="history_table"
            data={dataTable}
            columns={columns}
            getRowCanExpand={() => true}
            renderSubComponent={renderSubComponent}
        />
    );
};

export default LicenseKeysTable;
